import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.access_token, data.user);
      toast.success("Accesso effettuato");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-accent flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <Link to="/">
          <Button variant="ghost" size="sm" className="text-white/80 hover:text-white hover:bg-white/10 gap-1.5 mb-4">
            <ArrowLeft className="w-4 h-4" /> Torna alla petizione
          </Button>
        </Link>
        <div className="rounded-2xl bg-card p-8 shadow-2xl">
          <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center text-primary-foreground mb-5">
            <Lock className="w-6 h-6" />
          </div>
          <h1 className="font-heading text-2xl font-extrabold tracking-tight">Area Organizzatori</h1>
          <p className="text-sm text-muted-foreground mt-1 mb-6">
            Accedi per gestire la petizione e le firme.
          </p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="admin-login-email-input"
                className="mt-1.5 rounded-xl"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="admin-login-password-input"
                className="mt-1.5 rounded-xl"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit-button"
              disabled={loading}
              className="w-full rounded-xl h-11 font-semibold"
            >
              {loading ? "Accesso..." : "Accedi"}
            </Button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
